<template>
    <td-dialog
        append-to-body="true"
        v-dialogDrag
        :title="$t(title)"
        :before-close="relatedSetDlgClose"
        :visible.sync="dialogRelatedSetVisible"
        width="800px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <el-form :model="formResourceInfo" ref="formResourceInfo" style="margin-right:20px;">
            <el-form-item>
                <el-col :span="8">
                    <el-col :span="20" align="center">{{ $t('common.PRODUCER') }}</el-col>
                    <el-col :span="4">
                        <td-button type="button" size="mini" style="width:60px;" @click="addProDomain">{{ $t('common.ADD_PRO') }}</td-button>
                    </el-col>
                </el-col>
                <el-col :span="8" align="center">{{ $t('common.QUEUE') }}</el-col>
                <el-col :span="8">
                    <el-col :span="20" align="center">{{ $t('common.CONSUMER') }}</el-col>
                    <el-col :span="4">
                        <td-button type="button" size="mini" style="width:60px;" @click="addCsmDomain">{{ $t('common.ADD_CSM') }}</td-button>
                    </el-col>
                </el-col>
            </el-form-item>
            <el-form-item>
                <el-col :span="8">
                    <el-form-item v-for="(domain, index) in formResourceInfo.proDomains" :key="domain.key" :prop="'proDomains.' + index + '.value'">
                        <el-col :span="20">
                            <td-select v-model="domain.value" :options="proOptions"></td-select>
                        </el-col>
                        <el-col :span="4">
                            <td-button type="button" size="mini" style="width:60px;" @click="removeProDomain(domain)">{{ $t('common.DELETE') }}</td-button>
                        </el-col>
                    </el-form-item>
                </el-col>
                <el-col :span="8" align="center">{{ $t(sChannelName) }}</el-col>
                <el-col :span="8">
                    <el-form-item v-for="(domain, index) in formResourceInfo.csmDomains" :key="domain.key" :prop="'csmDomains.' + index + '.value'">
                        <el-col :span="20">
                            <td-select v-model="domain.value" :options="csmOptions"></td-select>
                        </el-col>
                        <el-col :span="4">
                            <td-button type="button" size="mini" style="width:60px;" @click="removeCsmDomain(domain)">{{ $t('common.DELETE') }}</td-button>
                        </el-col>
                    </el-form-item>
                </el-col>
            </el-form-item>
            <el-form-item>
                <td-button type="primary" @click="submitForm">{{ $t('common.SAVE') }}</td-button>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button type="primary" @click="submitForm">{{ $t('common.SAVE') }}</td-button>
            <td-button @click="relatedSetDlgClose">{{ $t('common.CANCAL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import queueApi from '../assets/api.js';
export default {
    props: ['title', 'dialogRelatedSetVisible', 'editItem', 'listProInfo', 'listCsmInfo'],
    created() {
        this.sChannelName = this.editItem.sChannelName;
        if (this.listProInfo !== null && this.listProInfo.length > 0) {
            this.formResourceInfo.proDomains[0].value = this.listProInfo[0].value;
        }
        if (this.listCsmInfo !== null && this.listCsmInfo.length > 0) {
            this.formResourceInfo.csmDomains[0].value = this.listCsmInfo[0].value;
        }
    },
    // 定义变量
    data() {
        return {
            // 表单信息
            formResourceInfo: {
                csmSid: '',
                proSid: '',
                proDomains: [
                    {
                        value: ''
                    }
                ],
                csmDomains: [
                    {
                        value: ''
                    }
                ]
            },
            proOptions: this.listProInfo,
            csmOptions: this.listCsmInfo,
            sChannelName: ''
        };
    },
    // 定义并实现方法体
    methods: {
        // 提交数据
        submitForm() {
            let recIds = [];
            for (let index = 0; index < this.formResourceInfo.proDomains.length; index++) {
                if (this.formResourceInfo.proDomains[index].value !== '') {
                    recIds.push(this.formResourceInfo.proDomains[index].value);
                }
            }
            if (recIds == null || recIds.length < 1) {
                this.$message({ showClose: true, message: this.$t('common.PRODUCER_CAN_NOT_NULL'), type: 'warning' });
                return;
            }
            for (let index = 0; index < this.formResourceInfo.csmDomains.length; index++) {
                if (this.formResourceInfo.csmDomains[index].value !== '') {
                    recIds.push(this.formResourceInfo.csmDomains[index].value);
                }
            }
            if (recIds == null || recIds.length < 1) {
                this.$message({ showClose: true, message: this.$t('common.CONSUMER_CAN_NOT_NULL'), type: 'warning' });
                return;
            }
            let content = {
                sQueueId: this.editItem.sId,
                recIds: recIds
            };
            queueApi.addResQueueRelated(JSON.stringify(content), response => {
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('dialogRelatedSet/addResQueueRelated', response.data.statusMessage);
                    return;
                }
                this.$message({ showClose: true, message: this.$t('common.ADD_SUCCESS'), type: 'success' });
                this.relatedSetDlgClose();
                this.$emit('submit');
            });
        },

        // 新增生产者控件
        addProDomain() {
            this.formResourceInfo.proDomains.push({
                value: '',
                key: Date.now()
            });
        },

        // 删除生产者控件
        removeProDomain(item) {
            let proLength = this.formResourceInfo.proDomains.length;
            if (proLength < 2) {
                this.$message({ showClose: true, message: this.$t('common.AT_LEAST_CHOOSE_ONE'), type: 'warning' });
                return;
            }
            let index = this.formResourceInfo.proDomains.indexOf(item);
            if (index !== -1) {
                this.formResourceInfo.proDomains.splice(index, 1);
            }
        },

        // 新增消费者控件
        addCsmDomain() {
            this.formResourceInfo.csmDomains.push({
                value: '',
                key: Date.now()
            });
        },

        // 删除消费者控件
        removeCsmDomain(item) {
            let proLength = this.formResourceInfo.csmDomains.length;
            if (proLength < 2) {
                this.$message({ showClose: true, message: this.$t('common.AT_LEAST_CHOOSE_ONE'), type: 'warning' });
                return;
            }
            let index = this.formResourceInfo.csmDomains.indexOf(item);
            if (index !== -1) {
                this.formResourceInfo.csmDomains.splice(index, 1);
            }
        },

        // 关闭窗口之前需要调用的方法
        relatedSetDlgClose() {
            this.$emit('relatedSetDlgClose');
            this.$refs['formResourceInfo'].resetFields(); // 重置表单数据
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
